export const MEMBERSHIP_PERMISSIONS = {
  VIEW: "HR_MEMBERSHIP_VIEW",
  CREATE: "HR_MEMBERSHIP_CREATE",
  EDIT: "HR_MEMBERSHIP_EDIT",
  APPROVE: "HR_MEMBERSHIP_APPROVE",
  MANAGE: "HR_MEMBERSHIP_MANAGE",
  BOARD_UPDATE: "HR_MEMBERSHIP_BOARD_UPDATE",
  FINANCE_VIEW: "HR_MEMBERSHIP_FINANCE_VIEW",
  FINANCE_UPDATE: "HR_MEMBERSHIP_FINANCE_UPDATE",
  ICT_VIEW: "HR_MEMBERSHIP_ICT_VIEW",
  ICT_UPDATE: "HR_MEMBERSHIP_ICT_UPDATE",
  TRADE_VIEW: "HR_MEMBERSHIP_TRADE_VIEW",
  TRADE_UPDATE: "HR_MEMBERSHIP_TRADE_UPDATE",
  REPORT_VIEW: "HR_MEMBERSHIP_REPORT_VIEW",
  CONFIG_MANAGE: "HR_MEMBERSHIP_CONFIG_MANAGE",
  NOTIFICATION_VIEW: "HR_MEMBERSHIP_NOTIFICATION_VIEW",
  AUTOMATION_MANAGE: "HR_MEMBERSHIP_AUTOMATION_MANAGE",
} as const;